exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img {\n  max-width: 100%;\n  max-height: 200px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/ProductsModule/ProductFileAddDialogComponent/product-file-add.dialog.component.scss
// module id = ../../../../../src/ProductsModule/ProductFileAddDialogComponent/product-file-add.dialog.component.scss
// module chunks = main